module.exports = __webpack_public_path__ + "static/media/mungbeankitchari.9d0fcc14.jpg";